export default __webpack_public_path__ + "static/media/0x3b1a0c9252ee7403093ff55b4a5886d49a3d837a.fb838d02.webp";